import React from 'react';
import './UserEngage.scss';

const SignupText = () => {
  return (
    <div className="signup-text-section">
      <div className="overlay">
        <h2 className="main-title">Sign Up Today As A Learner To : </h2>
        <ul className="points-list">
          <li>Enhance your English speaking, listening, reading, and writing skills.</li>
          <li>Connect with fellow learners and tutors from diverse backgrounds.</li>
          <li>Participate in interactive sessions, games, and exercises.</li>
          <li>Receive feedback and guidance from experienced tutors.</li>
		  <li>Build confidence and achieve fluency in English.</li>
        </ul>
        <div className="spacer"></div>
        <h3 className="secondary-title">✧ Follow Us on Social Media ✧</h3>
        <div className="social-links">
          <a 
            href="https://www.linkedin.com/company/englishenclave/?viewAsMember=true" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="linkedin-link"
          >
            Follow Us on LinkedIn
          </a>
          <a 
            href="https://www.instagram.com/englishenclave_/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="instagram-link"
          >
            Follow Us on Instagram
          </a>
        </div>
      </div>
    </div>
  );
};

export default SignupText;
